import React, { Component } from 'react';
import Auth from '../auth';

export default class Header extends Component {
  render() {
  // console.log(process.env)

    const puskesmasProfile = JSON.parse(localStorage.getItem('puskesmasProfile'));
    return (
      <div className='container-fluid bg-success py-3'>
        <div className='row'>
          <div className='col-lg-6 offset-3'>
            <div className='d-flex justify-content-center'>
              <div>
                <img
                  src={process.env.REACT_APP_LOGO}
                  alt='logo'
                  height='100px'
                  className='float-left'
                />
              </div>
              <div className='text-center ml-3'>
                <h1 className='text-white display-4'>
                  {puskesmasProfile.name}
                </h1>
                <h2 className='text-white display-5'>
                  {puskesmasProfile.address}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
